export default __webpack_public_path__ + "static/media/Template6.dbf62e40.png";